import { render, staticRenderFns } from "./chat-emoji-select.vue?vue&type=template&id=1d1e9c0a&scoped=true&"
import script from "./chat-emoji-select.vue?vue&type=script&lang=js&"
export * from "./chat-emoji-select.vue?vue&type=script&lang=js&"
import style0 from "./chat-emoji-select.vue?vue&type=style&index=0&id=1d1e9c0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e9c0a",
  null
  
)

export default component.exports